module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "smooth-appear",
      rawName: "v-smooth-appear",
      value: ({
        elements: '.smooth-appear-project',
        wait: 200,
        duration: 500,
        delay: 10,
        translate: 30
      }),
      expression: "{elements: '.smooth-appear-project', wait: 200, duration: 500, delay: 10, translate: 30}"
    }],
    staticClass: "skills-list"
  }, [_vm._l((_vm.items), function(item, index) {
    return [(item === '<br>') ? _c('br', {
      key: index
    }) : _c('div', {
      key: index,
      staticClass: "item smooth-appear-project"
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-093b7478","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SkillsList.vue
// module id = 154
// module chunks = 1